import React, { forwardRef } from "react";
import { NumericFormat } from "react-number-format";
import classNames from "classnames";
import Portal from "./../../layout/Portal";
import Validation from "./Validation";

const Input = forwardRef(
  (
    {
      type = "text",
      id,
      name,
      className,
      required,
      placeholder,
      autoComplete,
      ariaDescribedby,
      ariaLabelledby,
      ariaLabel,
      list,
      title,
      size,
      disabled,
      readOnly,
      multiple,
      value,
      min,
      max,
      step,
      isValid,
      isTouched,
      invalidFeedback,
      validFeedback,
      isValidMessage = true,
      isTooltipFeedback,
      onBlur,
      onChange,
      onFocus,
      onInput,
      onInvalid,
      onSelect,
      component,
      mask,
      format,
      ...props
    },
    ref
  ) => {
    const PROPS = {
      id,
      name: name === null ? id : name,
      type: !list ? type : undefined,
      className: classNames(
        {
          "form-control": readOnly !== "plaintext" && type !== "range",
          "form-range": type === "range",
          "form-control-plaintext": readOnly === "plaintext",
          "form-control-color": type === "color",
          [`form-control-${size}`]: size,
          "is-invalid": !isValid && isTouched && invalidFeedback,
          "is-valid": !isValid && isTouched && !invalidFeedback,
        },
        className
      ),
      required,
      placeholder,
      title,
      list: list ? `${id}-list` : undefined,
      disabled,
      readOnly: !!readOnly,
      multiple,
      autoComplete,
      "aria-describedby": ariaDescribedby,
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledby,
      value: typeof value === "undefined" && type !== "file" ? "" : value,
      min,
      max,
      step,
      onBlur,
      onChange: readOnly ? undefined : onChange,
      onFocus,
      onInput,
      onInvalid,
      onSelect,
      ...props,
    };

    const NUMBER_FORMAT_PROPS = {
      mask,
      format,
      onBlur: () => onBlur,
      onChange: readOnly ? null : () => onChange,
      onFocus: () => onFocus,
      onInput: () => onInput,
      onInvalid: () => onInvalid,
      onSelect: () => onSelect,
    };

    const LIST = list && (
      <Portal>
        <datalist id={`${id}-list`}>
          {list.map((option) => (
            <option key={option} aria-labelledby={option} value={option} />
          ))}
        </datalist>
      </Portal>
    );

    const VALIDATION = isValidMessage && (
      <Validation
        isTouched={isTouched}
        invalidFeedback={invalidFeedback}
        validFeedback={validFeedback}
        isTooltip={isTooltipFeedback}
      />
    );

    if (component === "NumberFormat" || format) {
      return (
        <>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <NumericFormat ref={ref} {...PROPS} {...NUMBER_FORMAT_PROPS} />
          {LIST}
          {VALIDATION}
        </>
      );
    }

    return (
      <>
        <input ref={ref} {...PROPS} />
        {LIST}
        {VALIDATION}
      </>
    );
  }
);

export default Input;
